export const applicationIdentifier = 'internal_admin'
